import { Navigate, useSearchParams } from 'react-router';

import { safeReturnPath } from '@/shared/utils/safeReturnPath';

/**
 * `/login` — an alias, not a second sign-in.
 *
 * The tenant sign-in renders in place at `/` (see `RequireAuth`), so this only
 * redirects there, or to the internal page named by `?next=` when that is a
 * safe path on this origin. Anything else — another origin, a scheme, a
 * backslash trick, the alias itself — falls back to `/`, so it can neither
 * send anybody off-site nor loop.
 */
export function LoginAlias() {
  const [params] = useSearchParams();

  return <Navigate to={safeReturnPath(params.get('next')) ?? '/'} replace />;
}
